
<template>
<div>
  <div v-if="!isLoading" class="">
    <div v-if="item" class="">
      <div class="row">
        <div class="col-12"> 
          <div class="card mb-5">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Employment offer details</h5>
              <div class="dropdown dropstart no-arrow">
                <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ri-more-2-fill"></i>
                </button>
                <ul class="dropdown-menu">
                  <!-- <li>
                    <button @click="generateSlip()" class="dropdown-item"
                    type="button" >
                    Print Offer slip</button>
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="card-body position-relative">
              <div  class="row g-4"> 
                <div class="col-sm-6">
                  <label class="small text-muted">Status</label>
                  <p class="mb-0"><span v-html="statusBadge(item.status)"></span></p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Offer was sent on</label>
                  <p class="mb-0">{{ $filters.date(item.created_at,1) }}</p>
                </div>
                <div class="col-sm-6">
                  <div v-if="item.status == 'employed'">
                    <label class="small text-muted">Accepted on</label>
                    <p class="mb-0">{{ $filters.date(item.accepted_at, 1) }}</p>
                  </div>
                  <div v-if="item.status == 'rejected_employment'">
                    <label class="small text-muted">Rejected on</label>
                    <p class="mb-0">{{ $filters.date(item.rejected_at, 1) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.status === 'pending_acceptance'" class="bd-callout mt-0 mb-5 bd-callout-warning">
            <accept-employment-form
              :edit-item="item"
              @updateItem="updateItem($event)"/>
          </div>
          <!-- <div v-else class="bd-callout mt-0 mb-5 bd-callout-info">
            <h4>Your Employment Slip. </h4>
            <div class="pt-4">
              <p class="mb-1">
                You can download this employment slip and present it to your employer as proof of your employment offer. 
              </p>
              <div class="mt-3">
                <button @click="generateSlip()" class="btn btn-primary"  type="button" >Print offer slip</button>
              </div>
            </div>
          </div> -->
          <div v-if="item.employment" class="card mb-5 overflow-hidden">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Employment Details</h5>
            </div>
            <div class="card-body">
              <div class="row g-3 g-lg-4">
                <div class="col-lg-6">
                  <label class="small text-muted">Employment ID</label>
                  <p class="mb-0">{{ item.employment.friendly_id }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Title</label>
                  <p class="mb-0">{{item.employment.title}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Employment type</label>
                  <p class="mb-0">{{$filters.textFromSlug(item.employment.type)}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Phone Number</label>
                  <p class="mb-0">{{item.employment.mobile}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Email</label>
                  <p class="mb-0">{{item.employment.email}}</p>
                </div>
                <div class="col-sm-6">
                  <label class="mb-0 text-muted">Start Date</label>
                  <p class="mb-0 mt-2 pt-1">{{ $filters.date(item.employment.start_date) }}</p>
                </div>
                <div v-if="item.employment.end_date" class="col-sm-6">
                  <label class="mb-0 text-muted">End Date</label>
                  <p class="mb-0 mt-2 pt-1">{{ $filters.date(item.employment.end_date) }}</p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Location/Venue </label>
                  <CommonAddress :item="item.employment" />
                </div>
                <div v-if="item.employment.canceled_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Canceled at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.employment.canceled_at, 1) }}</p>
                </div>
                <div class="col-12">
                  <label class="small text-muted">Description</label>
                  <div v-html="preText(item.employment.description)" class="mb-0"></div>
                </div>
              </div>          
            </div>
          </div>
          <div v-if="item.opportunity">
            <opportunity-detail-card  :item="item.opportunity" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <is-loading v-else />
</div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import AcceptEmploymentForm from '@/components/forms/AcceptEmploymentForm.vue'

export default {
  name: "employment-show",
  components:{
    IsLoading,
    OpportunityDetailCard,
    AcceptEmploymentForm
  },
  data() {
    return {
      isLoading: true,
      popupModalShow: false,
      item: null,
    }
  },
  watch: {
    '$route.params.offerId': function (id){
      if(id) this.fetchItem()
    },
  },
  methods: {
    updateItem(item){
      this.item = Object.assign(this.item, item);
    },
    fetchItem(){
      this.isLoading = true
      this.$http.get(`/employment-offers/${this.$route.params.offerId}/show`)
      .then((response) => {
        this.isLoading = false
        if(response.data.success){
          this.item = response.data.data
        }else{
          // this.$router.push({path: '/error-404'})
        }
      })
    },
    generateSlip(){
      const payload = {
        url: `/employment-offers/${this.item.id}/slip`,
        data: {}
      }
      this.$store.dispatch("changeLoaderValue", true)
      this.pdfFileExport(payload)
        .then((response) => {
          this.$store.dispatch("changeLoaderValue", false)
        }).catch((error) => {
          this.$store.dispatch("changeLoaderValue", false)
        })
    },
    initializeAll(){
      this.popupModalShow = false;
    }
  },
  created(){
    this.fetchItem()
  },
}

</script>

